import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Message } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-announcement-modal',
  templateUrl: './announcement-modal.component.html',
  styleUrls: ['./announcement-modal.component.scss'],
  standalone: false
})
export class AnnouncementModalComponent {
  announcements: Message[] = [];
  showTravelAdviceCondition = false;
  checkboxId = 'suppress_announcement_modal';

  constructor(public activeModal: NgbActiveModal) {}

  onDeleteAnnouncement(id: string): void {
    this.activeModal.close({ action: 'delete', id });
  }

  onSuppressAnnouncement(id: string): void {
    this.activeModal.close({ action: 'suppress', id });
  }
}

LightningModalTypes.AnnouncementModalComponent.component = AnnouncementModalComponent;
